import { UrlApi } from "../../services/apirest";
import { enviarmails } from "../../services/services";
import { armaMailFactAprobada, armaMailNuevaFact,armaMailAprobadoTec,armaMailDesaprobado } from "./armaMail";
import { armaMailAdministracion } from "./armaMailAdministracion";
import { useNavigate } from "react-router-dom";

//Post a factibilidades, clientes, domicilios y artefactos:
export async function postFactibilidades(
  e,
  ruta,
  reqBody,
  setNotify,
  mailAutorizante,
  comercial,
  cliente,
  domicilio,
  kganual,
  mailComercial
) {
  e.preventDefault();
  const Url = UrlApi + ruta;
  const response = await fetch(Url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(reqBody),
  });
  if (response.ok === false) {
    setNotify({
      open: true,
      severity: "error",
      color: "#FADBD8",
      mensaje: "Error al guardar",
    });
  } else {
    try {
      const json = await response.json();
      if (json.message) {
        setNotify({
          open: true,
          severity: "success",
          color: "#D4EFDF",
          mensaje: "Guardado",
        });

        const mail=armaMailNuevaFact(cliente,domicilio, kganual, comercial);
        enviarmails(
          `${mailAutorizante};${mailComercial}`,
          "Nueva Factibilidad Por Revisar",mail
          
        );
      } else if (json.sqlMessage) {
        setNotify({
          open: true,
          severity: "error",
          color: "#FADBD8",
          mensaje: "Error al guardar",
        });
      } else {
        setNotify({
          open: true,
          severity: "error",
          color: "#FADBD8",
          mensaje: "Error al guardar",
        });
      }
    } catch (error) {
      if (error.toString().includes("is not valid JSON")) {
        setNotify({
          open: true,
          severity: "success",
          color: "#D4EFDF",
          mensaje: "Guardado",
        });
      } else {
        setNotify({
          open: true,
          severity: "error",
          color: "#FADBD8",
          mensaje: "Error al guardar",
        });
      }
    }
  }
}

//PUT factibilidades
export async function putFactibilidades(e, ruta, reqBody, setNotify) {
  e.preventDefault();
  const Url = UrlApi + ruta;
  const response = await fetch(Url, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(reqBody),
  });
  if (response.ok === false) {
    setNotify({
      open: true,
      severity: "error",
      color: "#FADBD8",
      mensaje: "Error al guardar",
    });
  } else {
    try {
      const json = await response.json();
      if (json.message) {
        setNotify({
          open: true,
          severity: "success",
          color: "#D4EFDF",
          mensaje: "Guardado",
        });
      } else if (json.sqlMessage) {
        setNotify({
          open: true,
          severity: "error",
          color: "#FADBD8",
          mensaje: "Error al guardar",
        });
      } else {
        setNotify({
          open: true,
          severity: "error",
          color: "#FADBD8",
          mensaje: "Error al guardar",
        });
      }
    } catch (error) {
      if (error.toString().includes("is not valid JSON")) {
        setNotify({
          open: true,
          severity: "success",
          color: "#D4EFDF",
          mensaje: "Guardado",
        });
      } else {
        setNotify({
          open: true,
          severity: "error",
          color: "#FADBD8",
          mensaje: "Error al guardar",
        });
      }
    }
  }
}

//PUT factibilidades
export async function putFactibilidadesClienteExistente(e, ruta, reqBody, setNotify) {
  e.preventDefault();
  const Url = UrlApi + ruta;
  const response = await fetch(Url, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(reqBody),
  });
  if (response.ok === false) {
    setNotify({
      open: true,
      severity: "error",
      color: "#FADBD8",
      mensaje: "Error al guardar",
    });
  } else {
    try {
      const json = await response.json();
      if (json.message) {
        setNotify({
          open: true,
          severity: "success",
          color: "#D4EFDF",
          mensaje: "Guardado",
        });
      } else if (json.sqlMessage) {
        setNotify({
          open: true,
          severity: "error",
          color: "#FADBD8",
          mensaje: "Error al guardar",
        });
      } else {
        setNotify({
          open: true,
          severity: "error",
          color: "#FADBD8",
          mensaje: "Error al guardar",
        });
      }
    } catch (error) {
      if (error.toString().includes("is not valid JSON")) {
        setNotify({
          open: true,
          severity: "success",
          color: "#D4EFDF",
          mensaje: "Guardado",
        });
      } else {
        setNotify({
          open: true,
          severity: "error",
          color: "#FADBD8",
          mensaje: "Error al guardar",
        });
      }
    }
  }
}

export async function aprobarTec(
  e,
  ruta,
  reqBody, //Este req.body es el cuerpo del reclamo que se registra cuando se aprueba una factibilidad, por lo tanto se levanta un reclamo de instalación.
  setNotificacion,
  mail_autorizante_creditos,
  idfactibilidad,
  cliente,
  mailComercial,
  mails //son los mails de los usuarios de cuenta corriente
) {
  const Url = UrlApi + ruta;
  const response = await fetch(Url, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(reqBody),
  });
  if (!response.ok) {
    setNotificacion({
      open: true,
      mensaje: "Error al conectar con la base de datos.",
      severity: "error",
      color: "#FADBD8",
    });
    throw new Error(
      `Error al realizar la solicitud: ${response.status} ${response.statusText}`
    );
  } else {
    const json = await response.json();
    if (json.sqlMessage) {
      setNotificacion({
        open: true,
        mensaje: "Error SQL. Contacte a soporte.",
        severity: "error",
        color: "#FADBD8",
      });
      throw new Error(`SQL incorrecto (${json.errno})`);
    } else if (json.message) {
      setNotificacion({
        open: true,
        mensaje: "FACTIBILIDAD APROBADA",
        severity: "success",
        color: "#D4EFDF",
      });
      const mail = armaMailAprobadoTec(idfactibilidad, cliente)
      enviarmails(
        `${mail_autorizante_creditos};${mailComercial}`,
        "Análisis Crediticio Pendiente",mail
      );
      if(mails && mails.length > 0){
        // recinbo los mails y los separo knd
        const destinatarios = mails.join(";")
        enviarmails(destinatarios, "Análisis Crediticio Pendiente", mail)
      }
    } else {
      console.log("error desconocido");
    }
  }
}

export async function aprobarFactUser2(
  e,
  ruta,
  reqBody, //Este req.body es el cuerpo del reclamo que se registra cuando se aprueba una factibilidad, por lo tanto se levanta un reclamo de instalación.
  setNotificacion,
  receptor,
  factibilidad,
  autorizante,
  mailSolicitante,
  datosFactAprobar,
  url_autorizacion
) {

  e.preventDefault();

  const Url = UrlApi + ruta;
  // console.log("reclamo:" , reqBody)

  const response = await fetch(Url, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ reqBody, datosFactAprobar }),
  });

  if (!response.ok) {
    setNotificacion({
      open: true,
      mensaje: "Error al conectar con la base de datos.",
      severity: "error",
      color: "#FADBD8",
    });
    throw new Error(
      `Error al realizar la solicitud: ${response.status} ${response.statusText}`
    );
  } else {
    const json = await response.json();
    if (json.sqlMessage) {
      setNotificacion({
        open: true,
        mensaje: "Error SQL. Contacte a soporte.",
        severity: "error",
        color: "#FADBD8",
      });
      throw new Error(`SQL incorrecto (${json.errno})`);
    } else if (json.message) {
      setNotificacion({
        open: true,
        mensaje: "FACTIBILIDAD APROBADA",
        severity: "success",
        color: "#D4EFDF",
      });

      //siempre debe enviarse porque contiene la info de la factibilidad
      const mailConFormulario = armaMailAdministracion(factibilidad, 1, url_autorizacion)
      const mailInformativo=armaMailAdministracion(factibilidad, 0, url_autorizacion)

      enviarmails(
        `${receptor}`,
        "Factibilidad APROBADA",
        mailConFormulario,
      ); 
      enviarmails(
        `${autorizante}, ${mailSolicitante}`,
        "Factibilidad APROBADA - Información",
        mailInformativo,
      );
    } else {
      console.log("error desconocido");
    }
  }
}


// -------------------------------------------------------------------- // 

//PUT factibilidades
export async function deleteFact(e, ruta, setNotify) {
  e.preventDefault();
  const Url = UrlApi + ruta;
  const response = await fetch(Url, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    // body: JSON.stringify(reqBody),
  });
  if (response.ok === false) {
    setNotify({
      open: true,
      severity: "error",
      color: "#FADBD8",
      mensaje: "Error al eliminar",
    });
  } else {
    try {
      const json = await response.json();
      if (json.message) {
        setNotify({
          open: true,
          severity: "success",
          color: "#D4EFDF",
          mensaje: "FACTIBILIDAD ELIMINADA",
        });
      } else if (json.sqlMessage) {
        setNotify({
          open: true,
          severity: "error",
          color: "#FADBD8",
          mensaje: "Error al eliminar",
        });
      } else {
        setNotify({
          open: true,
          severity: "error",
          color: "#FADBD8",
          mensaje: "Error al eliminar",
        });
      }
    } catch (error) {
      if (error.toString().includes("is not valid JSON")) {
        setNotify({
          open: true,
          severity: "success",
          color: "#D4EFDF",
          mensaje: "Factibilidad Eliminada",
        });
      } else {
        setNotify({
          open: true,
          severity: "error",
          color: "#FADBD8",
          mensaje: "Error al eliminar",
        });
      }
    }
  }
}

export async function desaprobarFact(
  e,
  ruta,
  setNotificacion,
  mailSolicitante,
  factid,
  cliente,
  direccion,
  observaciones
) {
  const Url = UrlApi + ruta;
  const response = await fetch(Url, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id_estado: 212,
      rechazo_observaciones: observaciones,
      usuario_desaprueba: localStorage.getItem("user")
    }),
  });
  if (!response.ok) {
    setNotificacion({
      open: true,
      mensaje: "Error al conectar con la base de datos.",
      severity: "error",
      color: "#FADBD8",
    });
    throw new Error(
      `Error al realizar la solicitud: ${response.status} ${response.statusText}`
    );
  } else {
    const json = await response.json();
    if (json.sqlMessage) {
      setNotificacion({
        open: true,
        mensaje: "Error SQL. Contacte a soporte.",
        severity: "error",
        color: "#FADBD8",
      });
      throw new Error(`SQL incorrecto (${json.errno})`);
    } else if (json.message) {
      setNotificacion({
        open: true,
        mensaje: "FACTIBILIDAD DESAPROBADA",
        severity: "success",
        color: "#D4EFDF",
      });
      const mail = armaMailDesaprobado(factid, cliente, observaciones, direccion)
      enviarmails(
        `${mailSolicitante}`,
        "Factibilidad Desaprobada",mail
      );
    } else {
      alert("Error desconocido.");
      console.log("error desconocido");
    }
  }
}
